<div>
    <button 
        (click)="submit()"
        class="btn mx-2" 
        [ngClass]="{
            'btn-danger': validationError || (!warning && form.type === REQUEST_BUTTON_TYPES.DELETION && !request.isLoading && request.hasError === undefined),
            'btn-warning': warning || request.hasError || request.hasErrorCliExists,
            'btn-primary': !validationError && !warning && form.type !== REQUEST_BUTTON_TYPES.DELETION && !request.isLoading && request.hasError === undefined,
            'btn-success': !validationError && !warning && request.hasError === false,
            'btn-secondary': request.isLoading
        }" 
        [disabled]="request.isLoading || (request.hasError === false && lockOnSuccess)"
    >
        <i 
            class="fa mx-2" 
            [ngClass]="{
                'fa-exclamation-triangle': validationError || warning || request.hasError || request.hasErrorCliExists,
                'fa-save': form.type === REQUEST_BUTTON_TYPES.DUPLICATION || form.type === REQUEST_BUTTON_TYPES.EDITION || (!form.type && !validationError && !warning),
                'fa-pencil': form.type === REQUEST_BUTTON_TYPES.EDITION,
                'fa-trash': !warning && form.type === REQUEST_BUTTON_TYPES.DELETION,
                'fa-check': !validationError && !warning && request.hasError === false,
                'fa-spinner fa-spin': request.isLoading
            }" 
            aria-hidden="true"
        ></i>
        <span [innerHTML]="buttonLabel"></span>

        @if(
            !lockOnSuccess && 
            request.hasError === false && 
            (form.type === REQUEST_BUTTON_TYPES.DUPLICATION || form.type === undefined)
        ){
            <span>{{ form.type === REQUEST_BUTTON_TYPES.DUPLICATION ? 'Duplicar otro' : 'Crear otro' }}</span>
        }
    </button>
</div>